import { Component } from '@angular/core';

import {AlertController, App, ModalController, NavController, NavParams, ToastController} from 'ionic-angular';
import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';
import { UserData } from '../../../providers/user-data';
import {UiData} from "../../../providers/ui-data";
import {FormGroup, FormBuilder, FormControl, Validators} from '@angular/forms';
import {HomePage} from "../../home/home";
import {DocumentSelectForm} from "../../utils/document-select/document-select";
import {CvAddForm} from "../cv/form/cvform";
import {Observable} from "rxjs/Observable";


@Component({
  selector: 'page-account-complete',
  templateUrl: 'complete.html'
})
export class AccountCompletePage {
  username: string;
  countryList: any;
  civilityRef: any;
  civilityData: any;
  civilityForm : FormGroup;
  submitAttempt: boolean = false;
  modified: boolean = true;
  user: any;

    certificatesRef: any;
    certificates: Observable<any[]>;

  constructor(
      public alertCtrl: AlertController,
      public nav: NavController,
      public userData: UserData,
      public uiData: UiData,
      public afDatabase: AngularFireDatabase,
      private formBuilder: FormBuilder,
      public app: App,
      public toastCtrl: ToastController,
      public navParams: NavParams,
      public modalCtrl: ModalController,
  ) {

      var formData = {};
      this.civilityData = {}
      ;
      /*
      {
          civility: [null, Validators.required],
          nom: ['', [Validators.required,Validators.minLength(2)]],
          prenom: ['', [Validators.required,Validators.minLength(2)]],
          birthday: ['', [Validators.required]],
          email: ['', [Validators.required, Validators.email]],
          phone: ['', [Validators.required, Validators.pattern(/^(?:0|\(?\+33\)?\s?|0033\s?)[1-79](?:[\.\-\s]?\d\d){4}$/)]],

      }
       */
      /*vitale: [null, [Validators.required ]],
          last_visit: ['', [Validators.required]],
          rib_info: ['', [Validators.required]],
          identity: [null, [Validators.required ]],
          domicile: [null, [Validators.required ]],*/
      console.log(this.navParams.data);
      if(this.navParams.data.identity != undefined && this.navParams.data.identity==0)
      {
          formData['identity'] = [null, [Validators.required ]];
          this.civilityData['identity']='';
      }
      if(this.navParams.data.iban != undefined && this.navParams.data.iban==0)
      {
          formData['rib'] = [null, [Validators.required ]];
          this.civilityData['rib']='';
      }
      if(this.navParams.data.address != undefined && this.navParams.data.address==0)
      {
          formData['domicile'] = [null, [Validators.required ]];
          this.civilityData['domicile']='';
      }
      if(this.navParams.data.vitale != undefined && this.navParams.data.vitale==0)
      {
          formData['vitale'] = [null, [Validators.required ]];
          this.civilityData['vitale']='';
      }
      if(this.navParams.data.certificates != undefined && this.navParams.data.certificates==0)
      {
          formData['certificates'] = [null, [Validators.required ]];
          this.civilityData['certificates']='';
      }
      if(this.navParams.data.visit != undefined && this.navParams.data.visit==0)
      {
          formData['last_visit'] = [null, [Validators.required ]];
          this.civilityData['last_visit']='';
          this.civilityData['no_visit']=false;
      }
      console.log(formData);
      this.civilityForm = this.formBuilder.group(formData);
  }

  change()
  {
      this.modified=true;
  }
  ngAfterViewInit() {
      var that = this;
    this.userData.load().subscribe(data => {
        that.user = data;

        if(that.user.identity)
        {
            if(that.user.identity.secu)    this.civilityData.secu = that.user.identity.secu;
            if(that.user.identity.last_visit)    this.civilityData.last_visit = that.user.identity.last_visit;
        }
        if(that.civilityData.last_visit && that.civilityData.last_visit=="2000-01-01")
        {
            that.civilityData.no_visit = true;
        }
        if(that.user.documents)
        {
            if(that.user.documents.vitale)
                this.civilityData.vitale = that.user.documents.vitale.url;
            if(that.user.documents.identity)
                this.civilityData.identity = that.user.documents.identity.url;
            if(that.user.documents.domicile)
                this.civilityData.domicile = that.user.documents.domicile.url;
            if(that.user.documents.rib)
                this.civilityData.rib = that.user.documents.rib.url;
            if(that.user.documents.rib_info)
                this.civilityData.rib_info = that.user.documents.rib_info;
        }
        that.certificatesRef = that.userData.getUserDbListReference('certificates');
        that.certificates = that.certificatesRef.valueChanges();
        that.certificates.subscribe(function(data){
            //data=[];
            if(data.length!=0)
            {
                that.civilityData.certificates="not-empty";
            }
            if(data.length==0)
            {
                that.civilityData.certificates="";
            }
        });
    });

  }
    addVitale()
    {
        this.chooseDocument('vitale') ;
    }
    addDomicile()
    {
        this.chooseDocument('domicile') ;
    }
    addIdentity()
    {
        this.chooseDocument('identity') ;
    }
    addRib()
    {
        this.chooseDocument('rib') ;
    }
    chooseDocument(mode)
    {

        var multiple = false;
        var hideCamera = false;
        var fileExtensions:any = false;
        var allowFileTypes:any = false;

        if(mode == "identity" || mode.indexOf('other') > -1 || mode.indexOf('certificate') > -1){
            multiple = true;
        }
        if(mode == "cv"){
            hideCamera = true;
            fileExtensions = ".doc, .docx, .pdf, .odt";
            allowFileTypes = "application/pdf , application/msword , application/vnd.openxmlformats-officedocument.wordprocessingml.document , application/vnd.oasis.opendocument.text";
        }
        let documentSelectModal = this.modalCtrl.create(DocumentSelectForm, {
            document_type: mode,
            multiple: multiple,
            hideCamera:hideCamera,
            fileExtensions:fileExtensions,
            allowFileTypes:allowFileTypes
        });
        documentSelectModal.onDidDismiss(data => {
            if(data && data.document_type)
            {
                this.civilityData[data.document_type] = data.url;
            }
            else
            {

            }
        });
        documentSelectModal.present();
    }
    /****
     * Add or update Certificate
     * Use Modal controller with parameters
     ****/
    addCertificateModal() {
        let profileModal = this.modalCtrl.create(CvAddForm, { mode: "certificates", ref:this.certificatesRef, object: null });
        profileModal.onDidDismiss(data => {
            if(data.success)
            {
                this.toastSuccess('Certificat/Permis ajouté.');
                this.userData.triggerPortalSync({});
            }
            else
            {

            }
        });
        profileModal.present();
    }
    updateCertificateModal(object) {
        let profileModal = this.modalCtrl.create(CvAddForm, { mode: "certificates", ref:this.certificatesRef, object: object });
        profileModal.onDidDismiss(data => {
            if(data.success)
            {
                this.toastSuccess('Certificat/Permis modifié.');
                this.userData.triggerPortalSync({});
            }
            else
            {

            }
        });
        profileModal.present();
    }
    noVisit() {
        var that = this;
        if(that.civilityData.no_visit)that.civilityData.last_visit='2000-01-01';
    }
    savecivility() {

      var that = this;
      this.submitAttempt=true;


      if(this.civilityForm.valid)
      {
          let prompt = this.alertCtrl.create({
              title: 'Confirmation des informations',
              message: that.uiData.getDataValidationWarning(),
              buttons: [
                  {
                      text: 'Oui',
                      handler: data => {
                          that.userData.update('identity','last_visit',that.civilityData.last_visit);

                          that.toastSuccess('Vos informations ont été enregistrées.');
                          that.nav.pop();
                      }
                  },
                  {
                      text: 'Annuler',
                      handler: data => {

                      }
                  }
              ]
          });
          prompt.present();
      }
      else
      {
          console.log(this.civilityForm.value);
      }

  }
    toastSuccess(message: string)
    {
        let toast = this.toastCtrl.create({
            showCloseButton: true,
            cssClass: 'profile-bg',
            message: message,
            duration: 2000,
            position: 'bottom',
            closeButtonText:'Ok'
        });
        toast.present();
    }



}



// WEBPACK FOOTER //
// ./src/pages/account/complete/complete.ts